import { Component, OnInit, Input } from '@angular/core';
import { NavController, NavParams } from '@ionic/angular';

import { ConfigService } from 'src/app/config.service';
import { SAMService } from 'src/app/sam/sam.service';
import { BasePage, Helpers, ThemeService } from 'ngx-elvis-ds';
import { I18NService } from 'src/app/services/i18n.service';
import { ImageHelpers } from 'src/app/base/image-helpers';

export class FunctionDialogCommands {
  public static OPEN = ['FUNCTION_DIALOG_OPEN'];
  public static UPDATE = ['FUNCTION_DIALOG_UPDATE'];
  public static CLOSE = ['FUNCTION_DIALOG_CLOSE'];
}

@Component({
  selector: 'app-function-dialog',
  templateUrl: './function-dialog.page.html',
  styleUrls: ['./function-dialog.page.scss'],
})
export class FunctionDialogPage extends BasePage implements OnInit {

  @Input() data: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public sam: SAMService,
    public configSvc: ConfigService,
    public themeSvc: ThemeService,
    public i18nSvc: I18NService
  ) {
    super();
  }

  ngOnInit() {
    if (this.data.Tenders && !this.data.Items) {
      this.data.Items = this.data.Tenders;
    }
    
    if (this.data.Items) {
      for (const tender of this.data.Items) {
        if (tender.Img) {
          tender.Img = ImageHelpers.getImageURL('function-dialog-images', tender.Img, this.configSvc);
        }
      }
    }
  }

  onCallback(selection?: any) {
    if (selection) {
      this.sam.onSend({
        Command: 'ID_SELECTED',
        Val: selection.Id.toString()
      });
    } else {
      this.sam.onSend({
        Command: 'ID_SELECTED',
        Val: (-1).toString()
      });
    }
  }

}
